module.exports = __webpack_public_path__ + "static/media/ma_notification_icon.5918fe2c.svg";